import { Service } from '@roc/feature-app-core';
import { BaseBorrowerLoanSubmissionService } from './baseBorrowerLoanSubmissionService';

const url = {
  SFR_SIZER_LOAN_TERMS: '/api/v1/pricer/getSfrSizerLoanTerms',
  BORROWER_ENTITIES: '/api/v1/loan/borrowerEntity/getAllEntities',
  BORROWER_SUBMISSION_FEES: '/api/v1/pricer/getBorrowerSubmissionPricingFees',
  SUBMIT_LOAN_APPLICATION:
    '/api/v1/loan/loanApplications/submitLoanApplication',
  GET_CURRENT_USER_BORROWER:
    '/api/v1/loan/loanApplications/getCurrentUserBorrower',
  SUBMIT_PUBLIC_LOAN_APPLICATION:
    '/api/v1/loan/public/loanApplications/submitPublicLoanApplication',
  SEND_ERROR_EMAIL: '/api/v1/user/public/sendErrorEmail',
  SUBMIT_TERM_LOAN_APPLICATION:
    '/api/v1/loan/loanApplications/submitTermLoanApplication',
  SUBMIT_PUBLIC_TERM_LOAN_APPLICATION:
    '/api/v1/loan/public/loanApplications/submitPublicTermLoanApplication',
  RATES_SCENARIOS: '/api/v1/pricer/ratesDictionaryScenarios',
  RATES_SINGLE_QUOTE: '/api/v1/pricer/ratesSingleScenario',
  ADJUST_RATES_SINGLE_QUOTE: '/api/v1/pricer/adjustRateScenario',
  GET_YIELD_SPREAD_FOR_RATE_CHANGE: '/api/v1/pricer/getYieldSpreadForRateChange',
  YIELD_SPREAD_SCENARIOS: '/api/v1/pricer/yieldSpreadPremiumScenarios',
  SINGLE_SCENARIO_YIELD_SPREAD: '/api/v1/pricer/ratesBasedonYieldSpreadPremium',
  GET_RATE_SCENARIO_VALIDATION_ERRORS: '/api/v1/pricer/getRateScenarioValidationErrors',
  CALCULATED_DSCR: '/api/v1/pricer/dscr/calculateDscrValues',
  GET_LOAN_RATES_PDF_DATA: '/api/v1/pricer/getLoanRatesPdfData',
  GET_PREPAY_OPTIONS: '/api/v1/pricer/getPrepayOptions',
};
export class BorrowerLoanSubmissionService extends BaseBorrowerLoanSubmissionService {
  getAllEntities(
    filters?: string,
    page?: number,
    pageSize?: number,
    sortDir?: string,
    sortBy?: string
  ) {
    return this.get(url.BORROWER_ENTITIES, {
      page,
      pageSize,
      sortDir,
      sortBy,
      filters,
    });
  }

  submitLoanApplication(data) {
    return this.post(url.SUBMIT_LOAN_APPLICATION, data);
  }

  submitPublicLoaApplication(data, host, username, assignee?: string) {
    let requestUrl = `${url.SUBMIT_PUBLIC_LOAN_APPLICATION}?host=${host}&username=${username}`;
    if (assignee) {
      requestUrl += `&assignee=${encodeURIComponent(assignee)}`;
    }
    return this.post(requestUrl, data);
  }
  getRatesSingleQuote(data) {
    return this.post(url.RATES_SINGLE_QUOTE, data);
  }
  getRatesScenarios(data) {
    return this.post(url.RATES_SCENARIOS, data);
  }
  postPricerLoanTerms(data) {
    return this.post(url.SFR_SIZER_LOAN_TERMS, data);
  }
  getRateValidationErrors(data) {
    return this.post(url.GET_RATE_SCENARIO_VALIDATION_ERRORS, data);
  }
  getCalculatedValues(data) {
    return this.post(url.CALCULATED_DSCR, data);
  }
  getYieldSpreadPremiumScenarios(data) {
    return this.post(url.YIELD_SPREAD_SCENARIOS, data);
  }
  getSingleScenarioYieldSpread(data) {
    return this.post(url.SINGLE_SCENARIO_YIELD_SPREAD, data);
  }
  getCurrentUserBorrower() {
    return this.get(url.GET_CURRENT_USER_BORROWER);
  }
  getBorrowerSubmissionFees() {
    return this.get(url.BORROWER_SUBMISSION_FEES)
  }

  sendErrorEmail(
    subject: string,
    error: string,
    details: string,
    portalId: string
  ) {
    const body = {
      subject,
      body: `BrowserInfo: ${navigator.userAgent} Error message: ${error} \n Details: ${details}`,
    };
    return this.post(`${url.SEND_ERROR_EMAIL}?portalId=${portalId}`, body);
  }

  submitTermLoanApplication(data) {
    return this.post(url.SUBMIT_TERM_LOAN_APPLICATION, data);
  }

  submitPublicTermLoaApplication(data, host, username, assignee?: string) {
    let requestUrl = `${url.SUBMIT_PUBLIC_TERM_LOAN_APPLICATION}?host=${host}&username=${username}`;
    if (assignee) {
      requestUrl += `&assignee=${encodeURIComponent(assignee)}`;
    }
    return this.post(requestUrl, data);
  }

  getLoanRatesPdfData(data) {
    return this.post(url.GET_LOAN_RATES_PDF_DATA, data);
  }

  getPrepayOptions(data) {
    return this.post(url.GET_PREPAY_OPTIONS, data);
  }
}
